module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "hd research-background-color"
  }, [(!_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left navshare",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "header_title"
  }, [_vm._v("进展详情")])]), _vm._v(" "), (_vm.type === 'Tool') ? _c('tool-progress', {
    attrs: {
      "type": _vm.type,
      "progressInfo": _vm.progressInfo,
      "item": _vm.item,
      "sfQuoteNo": _vm.sfQuoteNo
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-829f1ade","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/User/MyResearchGroup/researchGroupProgress/ContractProgress.vue
// module id = 1686
// module chunks = 8